'use strict';

var _ = {
  map: function map(data, method) {
    var mapped = [];
    for (var key = 0; key < data.length; key++) {
      mapped.push(method(data[key], key));
    }
    return mapped;
  }
};
var UNKNOWN = 'UNKNOWN';

var Transformer = {};

Transformer.addToBasket = function (payload) {
  var outputPayload = {
    event: 'addToCart',
    ecommerce: {
      currencyCode: Transformer._extractCurrency(payload.products),
      add: {
        products: _.map(payload.products, Transformer._generateProductOutput)
      }
    }
  };

  return outputPayload;
};

Transformer.removeFromBasket = function (payload) {
  var outputPayload = {
    event: 'removeFromCart',
    ecommerce: {
      currencyCode: Transformer._extractCurrency(payload.products),
      remove: {
        products: _.map(payload.products, Transformer._generateProductOutput)
      }
    }
  };

  return outputPayload;
};

Transformer.productImpressions = function (payload) {
  var outputPayload = {
    ecommerce: {
      currencyCode: Transformer._extractCurrency(payload.products),
      impressions: _.map(payload.products, Transformer._generateProductOutput)
    }
  };

  if (payload.eventTrigger) {
    outputPayload.event = payload.eventTrigger;
  }
  return outputPayload;
};

Transformer.productClick = function (payload) {
  var outputPayload = {
    event: 'productClick',
    ecommerce: {
      currencyCode: Transformer._extractCurrency(payload.products),
      click: {
        actionField: Transformer._generateActionOutput(payload.booking),
        products: _.map(payload.products, Transformer._generateProductOutput)
      }
    }
  };

  return outputPayload;
};

Transformer.productDetails = function (payload) {
  var outputPayload = {
    ecommerce: {
      currencyCode: Transformer._extractCurrency(payload.products),
      detail: {
        actionField: Transformer._generateActionOutput(payload.booking),
        products: _.map(payload.products, Transformer._generateProductOutput)
      }
    }
  };

  if (payload.eventTrigger) {
    outputPayload.event = payload.eventTrigger;
  }

  return outputPayload;
};

Transformer.purchase = function (payload) {
  var outputPayload = {
    event: 'ecommerce',
    ecommerce: {
      currencyCode: Transformer._extractCurrency(payload.products),
      purchase: {
        actionField: Transformer._generateActionOutput(payload.booking),
        products: _.map(payload.products, Transformer._generateProductOutput)
      }
    }
  };

  if (payload.eventTrigger) {
    outputPayload.event = payload.eventTrigger;
  }

  return outputPayload;
};

Transformer.addToBooking = function (payload) {
  var outputPayload = {
    ecommerce: {
      currencyCode: Transformer._extractCurrency(payload.products),
      purchase: {
        actionField: Transformer._generateActionOutput(payload.booking),
        products: _.map(payload.products, Transformer._generateProductOutput)
      }
    }
  };

  return outputPayload;
};

Transformer.pageLoadEvent = function (system, payload) {
  var safePayload = payload || {};
  var event = {
    system: system || UNKNOWN,
    page_type: safePayload.page_type || safePayload.pageType || UNKNOWN,
    product_type: safePayload.product_type || safePayload.productType || UNKNOWN,
    product_code: safePayload.product_code || safePayload.productCode || UNKNOWN,
    location: (safePayload.data ? safePayload.data.location : safePayload.location) || UNKNOWN,
    event: 'page_load'

    // Support shortbreaks legacy GA reporting for now
  };if (payload && payload.shortbreaks) {
    event.shortbreaks = payload.shortbreaks;
  }

  return event;
};

Transformer.error = function (payload) {
  return {
    event: 'error',
    code: payload.code,
    exception: payload.exception,
    message: payload.message
  };
};

Transformer.view = function (payload) {
  var safePayload = payload || {};
  safePayload.event = 'view';
  return safePayload;
};

Transformer._generateProductOutput = function (product, index) {
  if (!product) return { position: index };
  var generatedProduct = {
    name: product.name,
    id: product.code,
    price: product.price,
    position: index
  };
  if (product.groupingName) {
    generatedProduct.name = product.groupingName;
    generatedProduct.variant = product.name;
  }
  if (product.location && product.location.code) {
    generatedProduct.name += ' ( ' + product.location.code + ' )';
  }
  if (product.brand) generatedProduct.brand = product.brand;
  if (product.position) generatedProduct.position = product.position;
  if (product.type) generatedProduct.category = product.type;
  if (product.list) generatedProduct.list = product.list;
  if (product.quantity) generatedProduct.quantity = product.quantity;
  if (product.voucher) generatedProduct.coupon = product.voucher;

  // There could be alot of these, lets just add them all rather than individually
  if (product.customDimensions) {
    for (var key in product.customDimensions) {
      generatedProduct[key] = product.customDimensions[key];
    }
  }

  return generatedProduct;
};

Transformer._generateActionOutput = function (booking) {
  var actionOutput = {};

  if (!booking) return actionOutput;
  if (booking.list) actionOutput.list = booking.list;
  if (booking.ref) actionOutput.id = booking.ref;
  if (booking.totalPrice) actionOutput.revenue = booking.totalPrice;
  if (booking.source) actionOutput.affiliation = booking.source;
  if (booking.tax) actionOutput.tax = booking.tax;
  if (booking.delivery) actionOutput.shipping = booking.delivery;
  if (booking.voucher) actionOutput.coupon = booking.voucher;

  return actionOutput;
};

Transformer._extractCurrency = function (products) {
  if (products && products[0] && products[0].currency) {
    return products[0].currency;
  }
  return 'GBP';
};

module.exports = Transformer;